"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptTermsAndConditions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const terms_of_service_modal_1 = require("../components/terms_of_service_modal");
const company_settings_1 = require("../context/company_settings");
const AcceptTermsAndConditions = ({ handleAcceptLatestTCs, handleOnDeclineTCs, isLoading, companySettings, preppingLobby, }) => {
    const CompanySettingsProvider = (0, company_settings_1.createCompanySettingsProvider)(companySettings);
    return ((0, jsx_runtime_1.jsx)(CompanySettingsProvider, { children: (0, jsx_runtime_1.jsx)(terms_of_service_modal_1.TermsOfServiceModal, { isOpen: true, isLoading: isLoading, onAccept: () => {
                handleAcceptLatestTCs();
            }, onDecline: () => {
                handleOnDeclineTCs();
            }, preppingLobby: preppingLobby }) }));
};
exports.AcceptTermsAndConditions = AcceptTermsAndConditions;
//# sourceMappingURL=accept_terms_and_conditions.js.map